"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthErrorUrl = exports.getErrorMessage = exports.destroyAccessInformation = exports.getAccessInformation = exports.saveAccessInformation = exports.getUserIdKey = exports.getTokenKey = exports.getApiUrl = exports.getReleoxOption = exports.setReleoxOptions = exports.getReleoxOptions = void 0;
const routes_1 = require("./routes");
const defaultOptions = {
    userIdKey: 'userId',
    tokenKey: 'accessToken',
    loginModelName: 'Members',
};
exports.getReleoxOptions = () => {
    const { RELEOX_OPTIONS } = window;
    if (RELEOX_OPTIONS === undefined)
        window.RELEOX_OPTIONS = defaultOptions;
    window.RELEOX_OPTIONS = Object.assign(Object.assign({}, defaultOptions), RELEOX_OPTIONS);
    return window.RELEOX_OPTIONS;
};
exports.setReleoxOptions = (object) => {
    const options = Object.assign(Object.assign({}, exports.getReleoxOptions()), object);
    window.RELEOX_OPTIONS = options;
    return window.RELEOX_OPTIONS;
};
exports.getReleoxOption = (key) => exports.getReleoxOptions()[key];
exports.getApiUrl = () => window.API_ENDPOINT || '';
exports.getTokenKey = () => exports.getReleoxOption('tokenKey');
exports.getUserIdKey = () => exports.getReleoxOption('userIdKey');
exports.saveAccessInformation = (accessToken, userId) => new Promise((resolve) => {
    localStorage.setItem(exports.getTokenKey(), accessToken);
    localStorage.setItem(exports.getUserIdKey(), userId);
    resolve();
});
exports.getAccessInformation = () => new Promise((resolve, reject) => {
    const accessToken = localStorage.getItem(exports.getTokenKey());
    const userId = localStorage.getItem(exports.getUserIdKey());
    if (!accessToken || !userId)
        return reject(new Error('Some Access Information cannot found'));
    return resolve({ accessToken, userId });
});
exports.destroyAccessInformation = () => new Promise((resolve) => {
    localStorage.removeItem(exports.getTokenKey());
    localStorage.removeItem(exports.getUserIdKey());
    return resolve();
});
exports.getErrorMessage = (error) => {
    let errorMessage = error.message;
    const res = error.response;
    if (res && typeof res.data !== 'string' && res.data.error.message)
        errorMessage = res.data.error.message;
    return errorMessage;
};
exports.getAuthErrorUrl = (message) => `${routes_1.routes.ERROR}?message=${message}`;
//# sourceMappingURL=config.js.map